import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

    private readonly path = '/document/validate';
  
    constructor(private http: HttpClient) {}
  
    validate(document: string): Observable<any> {
      const params = { document };
      return this.http.get<any>(`${environment.apiBaseUrl}${this.path}`, { params });
    }

}
